import React, { FC } from 'react'
import { useSelector } from 'react-redux'
import styles from 'styles/components/calendar.module.scss'
import { eachDayOfInterval, endOfWeek, eachWeekOfInterval, startOfMonth, endOfMonth } from 'date-fns'
import { MonthlyCalendarHeaderRow, CloseStoreCalendarRow } from 'components/Calendar/index'
import { StoreCalendarType } from 'types/storeCalendar'
import { getStoreCurrentMonth } from 'reducks/storeCalendar/selectors'
import { State } from 'index'

const getCalendarArray = (date: Date) => {
  const sundays = eachWeekOfInterval({
    start: startOfMonth(date),
    end: endOfMonth(date),
  })
  return sundays.map((sunday) => eachDayOfInterval({ start: sunday, end: endOfWeek(sunday) }))
}

type Props = {
  handleStoreCalendars: (storeCalendar: StoreCalendarType) => void
  storeCalendars: StoreCalendarType[]
}

const CloseStoreCalendar: FC<Props> = (props) => {
  const { handleStoreCalendars, storeCalendars } = props

  const currentMonth = useSelector((state: State) => getStoreCurrentMonth(state))
  const calendar = getCalendarArray(currentMonth)

  return (
    <table className={styles.table}>
      <thead>
        <MonthlyCalendarHeaderRow />
      </thead>
      <tbody>
        {calendar.map((row, rowNum) => (
          <CloseStoreCalendarRow
            key={rowNum}
            handleStoreCalendars={handleStoreCalendars}
            storeCalendars={storeCalendars}
            row={row}
          />
        ))}
      </tbody>
    </table>
  )
}

export default CloseStoreCalendar
